import React from 'react';
import SelectPopup from './SelectPopup';
import RFIDInstance from '../../../native-interact/RFID';
import { getCmdPage } from '../../../service/command';

const modules = [
  'cpu1',
  'cpu2',
  'nb',
  'lora',
  'geo'
];

export default function Reboot() {
  return (
    <SelectPopup
      title="重启"
      modules={modules}
      defaultSelectValue={modules[0]}
      onConfirm={(module) => {
        const cmd = `reboot ${module}`;
        return RFIDInstance.write(
          {
            step: `reboot_${module}`,
            desc: `重启${module}`
          },
          getCmdPage(cmd),
          cmd
        );
      }}
    />
  );
}
